/* deSal — offer coupon.

   Simple rule: whenever an item is ADDED to the cart, make sure the available
   offer coupon is applied. If it's already applied, do nothing. Clicking a card
   toggles it (apply / remove); a removed coupon comes back the next time an
   item is added.

   Applies by POSTing the code list to /cart/update.js (`discount` field), then
   a soft cart:update re-renders the cart section so the card + totals update
   from Liquid (the "proper transition"). */
(function () {
  if (window.__desalOffersInit) return;
  window.__desalOffersInit = true;

  var UPDATE_URL =
    (window.Theme && Theme.routes && Theme.routes.cart_update_url) || '/cart/update.js';

  // Codes currently on the cart, read from the (hidden) native pills.
  function appliedCodes() {
    var out = [];
    document.querySelectorAll('.cart-discount__pill').forEach(function (p) {
      var c = (p.dataset.discountCode || '').toUpperCase();
      if (c && out.indexOf(c) === -1) out.push(c);
    });
    return out;
  }

  // Our own cart mutation — tagged so the auto-apply listener ignores it.
  function notify(cart) {
    document.dispatchEvent(
      new CustomEvent('cart:update', {
        bubbles: true,
        detail: { resource: cart, sourceId: 'desal-offers', data: { source: 'desal-offers' } },
      })
    );
  }

  function setCodes(codes) {
    return fetch(UPDATE_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: codes.join(',') }),
    }).then(function (r) {
      return r.json();
    });
  }

  function applyCode(code) {
    var codes = appliedCodes();
    if (codes.indexOf(code) === -1) codes.push(code);
    return setCodes(codes).then(function (cart) {
      notify(cart);
      return cart;
    });
  }

  function removeCode(code) {
    var codes = appliedCodes().filter(function (c) {
      return c !== code;
    });
    return setCodes(codes).then(function (cart) {
      notify(cart);
      return cart;
    });
  }

  // Make sure the available offer code is on the cart. No-op if already applied.
  var applying = false;
  function ensureApplied() {
    if (applying) return;
    var card = document.querySelector('.desal-offer-card');
    if (!card || card.classList.contains('is-applied')) return; // none / already applied — fine
    var code = (card.dataset.offerCode || '').toUpperCase();
    if (!code) return;
    applying = true;
    // Show a spinner on the card while the apply + cart morph complete (a few
    // round-trips). The morph re-renders the card as applied, dropping this
    // class; on failure we clear it ourselves.
    card.classList.add('is-applying');
    applyCode(code)
      .catch(function () {
        card.classList.remove('is-applying');
      })
      .finally(function () {
        applying = false;
      });
  }

  // ── Click a card → toggle that code ─────────────────────────────────────
  document.addEventListener('click', function (event) {
    var chip = event.target && event.target.closest ? event.target.closest('.desal-offer-card') : null;
    if (!chip) return;
    event.preventDefault();
    if (chip.hasAttribute('disabled')) return;

    var code = (chip.dataset.offerCode || '').toUpperCase();
    if (!code) return;

    var applied = chip.classList.contains('is-applied');
    chip.setAttribute('disabled', 'disabled'); // the section morph replaces the chip and clears this

    (applied ? removeCode(code) : applyCode(code)).catch(function () {
      chip.removeAttribute('disabled');
      // Last-ditch fallback so a tap still does something useful.
      if (!applied) {
        window.location.href =
          '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(window.location.pathname);
      }
    });
  });

  // ── Auto-apply when an item is added ────────────────────────────────────
  // We watch the cart item COUNT and only apply when it goes UP. This keeps a
  // manual coupon removal from being instantly re-applied (removing a coupon,
  // or an item, doesn't raise the count) while still re-applying on the next
  // add. Reading the count from the DOM after the morph settles.
  function count() {
    var el = document.querySelector('[ref="cartItemCount"]');
    return el ? parseInt(el.textContent.trim(), 10) || 0 : 0;
  }
  var lastCount = count();

  // A cart change fired: poll briefly for the count to reflect the morph, then
  // apply if it grew. Bounded so it can't spin.
  function onCartChanged(tries) {
    var c = count();
    if (c !== lastCount) {
      var grew = c > lastCount;
      lastCount = c;
      if (grew) ensureApplied();
      return;
    }
    if (tries <= 0) return;
    setTimeout(function () {
      onCartChanged(tries - 1);
    }, 200);
  }
  document.addEventListener('cart:update', function (e) {
    if (e.detail && e.detail.sourceId === 'desal-offers') return; // ignore our own apply/remove
    onCartChanged(8); // ~1.6s window for the count to update
  });

  // Initial pass: apply once the offer card exists — covers the first add from
  // an empty cart (card is morphed in after the drawer opens) and a page that
  // loaded with items but no coupon yet.
  function initApply(tries) {
    if (document.querySelector('.desal-offer-card')) {
      lastCount = count();
      ensureApplied();
      return;
    }
    if (tries <= 0) return;
    setTimeout(function () {
      initApply(tries - 1);
    }, 200);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initApply(15);
    });
  } else {
    initApply(15);
  }
})();
